import React from 'react';
import { Platform } from 'react-native';
import { TouchableRipple } from 'react-native-paper';
import { Trans } from '@lingui/macro';

import Container from '@src/components/Container';
import Separator from '@src/components/Separator';
import { Body1, Subtitle1 } from '@src/components/Typography';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { useBook } from '@src/database/hooks';
import { Page } from '@src/database/models';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';

import { CH2, List, Row } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = ({
  navigation,
  route: {
    params: { id },
  },
}) => {
  const handleScroll = useAnimatedHeader();
  const book = useBook(id);
  const [pages, setPages] = React.useState<Page[]>([]);
  React.useEffect(() => {
    const fetch = async () => {
      if (Platform.OS === 'web') {
        let unSortedPage: Page[] = (await book.data?.pages.fetch()) ?? [];
        setPages(unSortedPage.sort((p1, p2) => p1.order - p2.order));
      } else {
        setPages((await book.data?.sortedPages.fetch()) ?? []);
      }
    };
    fetch().catch(console.log);
  }, [book.data]);

  React.useLayoutEffect(() => {
    if (book.data) {
      navigation.setOptions({
        title: book.data.title,
      });
    }
  }, [book.data, id, navigation]);

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          onScroll={handleScroll}
          data={pages}
          ListHeaderComponent={
            <>
              <Separator />
              <CH2>
                <Trans>Guide Menu</Trans>
              </CH2>
              <Separator />
              <Subtitle1>
                <Trans>Page</Trans>
              </Subtitle1>
            </>
          }
          renderItem={({ item, index }) => (
            <TouchableRipple
              onPress={() =>
                navigation.navigate('PrimeBookTextReader', { id, page: index })
              }
            >
              <Row>
                <Body1>{index + 1}</Body1>
                <Separator level={3} />
                <Body1>{item.topic?.name}</Body1>
              </Row>
            </TouchableRipple>
          )}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'PrimeBookMenu';

export default Screen;
